import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface TagTextProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode
  className?: string
}

export const TagText: FC<TagTextProps> = ({ children, className = '', ...rest }) => (
  <span className={`tag-text ${className}`} {...rest}>
    {children}
  </span>
)
